import script from "./EditorJsRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorJsRenderer.vue?vue&type=script&setup=true&lang=js"

import "./EditorJsRenderer.vue?vue&type=style&index=0&id=2dc65ff5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc65ff5"]])

export default __exports__